import { InstructorEmailBox } from "@views/users/trainee-detail/components/instructor.email-box";
import "./course-top-section.scss";
import { ToggleButton } from "@transfr-inc/dashboard-components/forms";
import { TextTooltip } from "@transfr-inc/dashboard-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SimPassButton } from "@components/sim-pass-button";
import { useSimPass } from "@lib/hooks";
import { Product } from "@transfr-inc/dashboard-components/constants";
import { SimPassProducts } from "@lib/product.utils";

export function CourseTopSection({
  classroom,
  course,
  instructors,
  onTogglePrereq,
  prereqEnabled,
  allowStudentPrereqToggle,
  isDemo,
  user,
}) {
  const product = classroom?.products?.find((p) => SimPassProducts.includes(p)) ?? Product.TS;

  const {
    deletingSimPass,
    generatingSimPass,
    simPass,
    generateSimPass,
    deleteSimPass,
  } = useSimPass({
    userId: user?.userId,
    classroomId: classroom?.classroomId,
    product,
  });

  return (
    <div className="course-top-section">
      <div className="course-info-instructors">
        <div className="title-section">
          <h2 className="title">
            {instructors?.length !== 1
              ? "Instructors"
              : "Instructor"}{" "}
            <span className="badge">{instructors?.length || 0}</span>
          </h2>
        </div>
        <div className="list">
          {!instructors && <div />}
          {instructors?.length > 0 ? (
            instructors.map((instructor) => (
              <InstructorEmailBox
                instructor={instructor}
                key={instructor.userId}
              ></InstructorEmailBox>
            ))
          ) : (
            <span>{"No instructors."}</span>
          )}
        </div>
      </div>
      <div className="course-info-description">
        <div className="title-section">
          <h2 className="title">Description</h2>
        </div>
        <div className="description">
          {course?.description || "No description."}
        </div>
      </div>
      {user?.userId && classroom?.classroomId && (
        <SimPassButton
          classroom={classroom}
          deletingSimPass={deletingSimPass}
          generatingSimPass={generatingSimPass}
          simPass={simPass}
          onClick={generateSimPass}
          onDelete={deleteSimPass}
        />
      )}
      {allowStudentPrereqToggle && !isDemo && (
        <div className="pre-req-toggle">
          <div className="title-section">
            <h2 className="title">Activity Prerequisites Enabled </h2>
          </div>
          <div className="description">
            Testing Purposes Only.{" "}
            <TextTooltip
              text={
                "This feature is not intended for production. " +
                "There may be some unexpected behavior in the status column, as well as the bottom/side navs in the activity player. " +
                "This is purely to allow testers to click any activity at any time."
              }
            >
              <FontAwesomeIcon icon={"fa-regular fa-circle-info"} />
            </TextTooltip>
          </div>
          <ToggleButton
            onChange={onTogglePrereq}
            value={prereqEnabled}
            affirmText={"YES"}
            negateText={"NO"}
          />
        </div>
      )}
    </div>
  );
}
